import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getFarmNameTuples } from "../../../../pages/map-page/store/map-page.selector";
import { fetchAvailableFarmsAction } from "../../../../pages/map-page/store/map-page.slice";
import { useAppDispatch } from "../../../../store";

import { AvailableFarmsStatus } from "./types";

export function useAvailableFarmsGate(): {
  status: AvailableFarmsStatus;
  retry: () => void;
} {
  const dispatch = useAppDispatch();
  const hasFarms = useSelector(getFarmNameTuples).length > 0;
  const [status, setStatus] = useState<AvailableFarmsStatus>("idle");

  const check = useCallback(() => {
    setStatus("loading");
    dispatch(fetchAvailableFarmsAction())
      .unwrap()
      .then((farmCount) => setStatus(farmCount === 0 ? "empty" : "ready"))
      .catch(() => setStatus("ready"));
  }, [dispatch]);

  useEffect(() => {
    if (!hasFarms && status === "idle") {
      check();
    }
  }, [hasFarms, status, check]);

  return { status: hasFarms ? "ready" : status, retry: check };
}
